export default __webpack_public_path__ + "static/media/0x24ad14a4f0bb79a9dcf201514cb0e651c79db76b.f88152a0.webp";